import { render, staticRenderFns } from "./AnalyticsOrders.vue?vue&type=template&id=900c906c"
import script from "./AnalyticsOrders.vue?vue&type=script&lang=js"
export * from "./AnalyticsOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports